import { Component, TemplateRef, ViewChild, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { catchError, EMPTY, first, tap } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent {
  private authService = inject(AuthService);
  private toastService = inject(ToastService);

  @ViewChild('dangerTpl')
  public dangerTpl!: TemplateRef<unknown>;
  public callbackError?: string;

  @ViewChild('successTpl')
  public successTpl!: TemplateRef<unknown>;
  public message = 'Посилання відправлено на вказаний email';

  public form: FormGroup;

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group({
      email: new FormControl<string>('', {
        nonNullable: true,
        validators: Validators.required,
      }),
    });
  }

  public submitForm(): void {
    this.authService
      .forgotPassword(this.form.get('email')?.value)
      .pipe(
        first(),
        tap(() => this.toastService.show({
          template: this.successTpl,
          className: 'bg-success text-light'
        })),
        catchError((error) => {
          this.callbackError = error.message;
          this.toastService.show({
            template: this.dangerTpl,
            className: 'bg-danger text-light',
          });

          return EMPTY;
        })
      )
      .subscribe();
  }
}
